import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import RoleTable from "./_components/RoleTable";
import {connect} from "react-redux";
import {roleActions} from "../../../actions/role.actions";
import {Link} from "react-router-dom";

class RolePage extends Component {

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(roleActions.getRoleList());
    }

    render() {
        const { t, roleList } = this.props;
        const breadcrumb = [
            { value: 'roles', path: '#' }
        ];

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <h4>{ t('roles') }</h4>
                <div className="card">
                    <div className="card-header">
                        <div className="button-group">
                            <Link className="btn btn-success float-right" to={`/panel/role/create`}>
                                <i className="fas fa-plus"> </i> <span>{t('create')}</span>
                            </Link>
                        </div>
                    </div>
                    <div className="card-body">
                        <RoleTable list={roleList} />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { roleList } = state.roleReducer;
    return {
        roleList
    }
};
export default withNamespaces()(connect(mapStateToProps)(RolePage));
